import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import logo from "../../Assets/Images/logomobile.png"; 


interface ExportProps {
  columns: { field: string; headerName: string }[];
  rows: any[];
}

const toBase64 = (url: string) =>
  fetch(url)
    .then((response) => response.blob())
    .then(
      (blob) =>
        new Promise<string>((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result as string);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        })
    );
/** 🔹 Export to Excel with header */
export const exportToExcel = ({ columns, rows }: ExportProps) => {
  const headers = columns.map((col) => col.headerName);
  const data = rows.map((row) =>
    columns.map((col) => (row[col.field] !== undefined ? row[col.field] : ""))
  );

  const worksheet = XLSX.utils.aoa_to_sheet([]);

  // 🔹 Add custom header
  const now = new Date().toLocaleString();
  XLSX.utils.sheet_add_aoa(worksheet, [["Everest Tutoring"]], { origin: "A1" });
  XLSX.utils.sheet_add_aoa(worksheet, [[`Exported: ${now}`]], { origin: "E1" });
  XLSX.utils.sheet_add_aoa(worksheet, [["Booklet Requests Report"]], {
    origin: "A3",
  });

  // 🔹 Add table headers + data
  XLSX.utils.sheet_add_aoa(worksheet, [headers], { origin: "A5" });
  XLSX.utils.sheet_add_aoa(worksheet, data, { origin: "A6" });

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Booklet Requests");

  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  const blob = new Blob([excelBuffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  saveAs(blob, "booklet_requests.xlsx");
};



export const exportToPDF = async ({ columns, rows }: ExportProps) => {
  const doc = new jsPDF("p", "mm", "a4");
  const pageWidth = doc.internal.pageSize.getWidth();

  // 🔹 Date + time formatted
  const now = new Date();
  const formattedDate = new Intl.DateTimeFormat("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  }).format(now);
  const formattedTime = new Intl.DateTimeFormat("en-GB", {
    hour: "2-digit",
    minute: "2-digit",
  }).format(now);

  // 🔹 Logo (larger, keep aspect ratio)
  const logoBase64 = await toBase64(logo);
  doc.addImage(logoBase64, "PNG", 10, 8, 50, 0);

  // 🔹 Date + time on top-right, two lines
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(formattedDate, pageWidth - 10, 12, { align: "right" });
  doc.text(formattedTime, pageWidth - 10, 18, { align: "right" });

  // 🔹 Title bold, centered
  doc.setFont("helvetica", "bold");
  doc.setFontSize(14);
  doc.text("Booklet Requests Report", pageWidth / 2, 40, { align: "center" });
  doc.setFont("helvetica", "normal");

  // 🔹 Table
  const headers = [columns.map((col) => col.headerName)];
  const data = rows.map((row) =>
    columns.map((col) => (row[col.field] !== undefined ? row[col.field] : ""))
  );

  autoTable(doc, {
    head: headers,
    body: data,
    startY: 50,
    styles: { fontSize: 9 },
    headStyles: { fillColor: [0, 157, 255], textColor: [255, 255, 255] },
    alternateRowStyles: { fillColor: [245, 245, 245] },
    margin: { left: 10, right: 10 },
  });

  doc.save("booklet_requests.pdf");
};
